import { render, staticRenderFns } from "./SelectList.vue?vue&type=template&id=521cab4b&scoped=true&"
import script from "./SelectList.vue?vue&type=script&lang=js&"
export * from "./SelectList.vue?vue&type=script&lang=js&"
import style0 from "./SelectList.vue?vue&type=style&index=0&id=521cab4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521cab4b",
  null
  
)

export default component.exports